import { render, staticRenderFns } from "./declareList.vue?vue&type=template&id=7e2ac7b4&scoped=true"
import script from "./declareList.vue?vue&type=script&lang=js"
export * from "./declareList.vue?vue&type=script&lang=js"
import style0 from "./declareList.vue?vue&type=style&index=0&id=7e2ac7b4&lang=less"
import style1 from "./declareList.vue?vue&type=style&index=1&id=7e2ac7b4&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ac7b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e2ac7b4')) {
      api.createRecord('7e2ac7b4', component.options)
    } else {
      api.reload('7e2ac7b4', component.options)
    }
    module.hot.accept("./declareList.vue?vue&type=template&id=7e2ac7b4&scoped=true", function () {
      api.rerender('7e2ac7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/courseDeclare/declareList.vue"
export default component.exports